import React from "react";

export default function MerchantStatCard({ stripeClassName, label, value, children }) {
  return (
    <div className="merchant-kpi-card">
      <div className={"merchant-kpi-stripe " + stripeClassName} />
      <div className="merchant-kpi-label">{label}</div>
      <div className="merchant-kpi-value">{value}</div>
      <div className="merchant-kpi-sub">{children}</div>
    </div>
  );
}
